<p-skeleton width="14rem" styleClass="mb-(--space-2)" />
<p-skeleton width="10rem" styleClass="mb-(--space-2)" />
<p-skeleton width="15rem" styleClass="mb-(--space-2)" />
<p-skeleton height="2rem" width="45rem" styleClass="mb-(--space-2)" />
<p-skeleton height="20rem" />
